window.PlummeI18n.register('no', {
  "km.driver.add": "Legg til fører under Lønn",
  "km.driver.addRequired": "Legg til personen som har kjørt under Lønn før du registrerer turen. Velg personens faktiske rolle, også når føreren er eier.",
  "km.driver.chooseRequired": "Velg personen som har kjørt før du lagrer turen.",

  "km.portal.all": "Alle",
  "km.portal.sent": "Sendt",
  "km.portal.approved": "Godkjent",
  "km.portal.inPayroll": "Med i lønn",
  "km.portal.rejected": "Avvist",
  "km.portal.draft": "Utkast",
  "km.portal.pendingPayroll": "Behandles videre i lønn når arbeidsgiver godkjenner.",
  "err.mileage.recipient": "Velg en navngitt mottaker og bekreft at riktig rolle er registrert.",
  "km.flow.profile": "Kontroller foretaksinnstillinger",
  "km.flow.profileHelp": "Land eller selskapsform mangler i de lagrede foretaksinnstillingene. Kontroller og lagre riktig selskapsform under Innstillinger → Foretak. Gå deretter tilbake til turen for å bokføre kilometerfradrag for ENK. Turen trenger ikke registreres på nytt.",
  "km.flow.savePost": "Lagre og bokfør kilometerfradrag",
  "km.flow.saveSubmit": "Lagre og send til reiseregning",
  "km.recipient.setup": "Koble eier til mottaker",
  "km.recipient.person": "Mottaker",
  "km.recipient.help": "Velg personen som skal motta godtgjørelsen. Personen registreres under Lønn med faktisk rolle: ansatt, frilanser eller styremedlem. Eier er ikke automatisk et ansettelsesforhold.",
  "km.recipient.create": "Åpne Lønn – registrer eller kontroller mottaker",
  "km.recipient.confirm": "Jeg bekrefter at personen er eieren som har kjørt, og at mottakerens rolle er riktig registrert.",
  "km.privateUse.standardConfirmed": "Jeg har avklart at standardreglene gjelder. Privatbruken er ikke sporadisk eller omfattet av andre særregler.",
  "km.privateUse.action": "Behandle privat bruk av virksomhetens bil",
  "km.privateUse.calculate": "Beregn til kontroll",
  "km.privateUse.transfer": "Legg til lønnsutkast",
  "km.privateUse.post": "Bokfør årlig tilbakeføring",
  "km.privateUse.help": "Standardberegning for Norge 2026. Privatkjøring gir ikke kilometerfradrag. Fri bil behandles per måned i lønn; innehaverens næringsbil behandles årlig. Individuell verdsetting per kilometer og delårsberegning for innehaver må vurderes separat.",
  "km.privateUse.month": "Måned (1–12)",
  "km.privateUse.class": "Kjøretøyklasse",
  "km.privateUse.passenger": "Personbil – standardregel",
  "km.privateUse.van": "Varebil klasse 2 – standardregel",
  "km.privateUse.price": "Listepris som ny, inkludert ekstrautstyr",
  "km.privateUse.firstYear": "År for førstegangsregistrering",
  "km.privateUse.businessNeed": "Jeg bekrefter tjenstlig behov for varebil klasse 2.",
  "km.privateUse.fullYear": "Bilen var tilgjengelig privat hele året. Årets kostnader er avklart.",
  "km.privateUse.monthAvailable": "Bilen var tilgjengelig privat i den valgte måneden.",
  "km.privateUse.financing": "Eie eller lease",
  "km.privateUse.owned": "Eid bil",
  "km.privateUse.leased": "Leaset bil",
  "km.privateUse.costs": "Årlige driftskostnader, uten avskrivning og leasing",
  "km.privateUse.leaseCosts": "Årlig leasingkostnad",
  "km.privateUse.evidence": "Henvisning til dokumentasjon av bil og kostnader",
  "km.privateUse.result": "Beregnet beløp til behandling",
  "km.privateUse.standard": "Standardfordel for hele året",
  "km.privateUse.ceiling": "75 % av beregnede bilkostnader",
  "km.privateUse.processed": "Behandlingen er opprettet. Kontroller videre status i bilaget eller lønnskjøringen. Korriger gjennom den opprinnelige føringen.",
  "km.privateUse.open": "Åpne behandling",
  "km.privateUse.run": "Lønnsutkast i fordelsmåneden",
  "km.privateUse.chooseRun": "Velg lønnsutkast",
  "km.privateUse.noRun": "Opprett først et lønnsutkast med lønnsdato i denne måneden under Lønn.",
  "km.privateUse.confirm": "Jeg har kontrollert grunnlaget og beløpet. Denne bilfordelen eller tilbakeføringen er ikke allerede tatt med på annen måte.",
  "km.privateUse.tripHelp": "Privatkjøringen er dokumentert, men eventuell bilfordel eller tilbakeføring må behandles separat. Bruk samme måneds- eller årsberegning for alle turene med bilen.",
  "km.privateUse.highMileage": "Over 40 000 km dokumentert yrkeskjøring med personbilen i året",
  "km.privateUse.logReference": "Henvisning til kvalifiserende elektronisk kjørebok",
  "km.flow.driver": "Fører",
  "km.flow.choose": "Velg fører",
  "km.flow.owner": "Innehaver / eier",
  "km.flow.car": "Biltype",
  "km.flow.privateCar": "Privatbil",
  "km.flow.companyCar": "Virksomhetens bil",
  "km.flow.name": "Navn på eier",
  "km.flow.policyHelp": "Standard er forhåndsvalgt. Velg statens sats bare dersom dette er avtalt med arbeidsgiver. Den høyere satsen er delvis skattepliktig.",
  "km.flow.policy": "Avtalt godtgjørelse (2026)",
  "km.flow.taxFree": "Standard – skattefri sats, 3,50 kr/km",
  "km.flow.government": "Statens sats – 5,30 kr/km (delvis skattepliktig)",
  "km.flow.failed": "Kunne ikke lagre turen. Prøv igjen.",
  "km.flow.estimated": "Beregnet beløp",
  "km.flow.registered": "Registrert – ikke bokført",
  "km.flow.sent": "Tilknyttet reiseregning",
  "km.flow.assign": "Velg / endre fører",
  "km.flow.post": "Bokfør kilometerfradrag",
  "km.flow.submit": "Send til reiseregning",
  "km.flow.viewTravel": "Vis reiseregning",
  "km.flow.viewVoucher": "Vis bilag",
  "km.flow.review": "Avklar godtgjørelse",
  "km.flow.confirmPrivate": "Jeg bekrefter at dette er innehaverens yrkeskjøring med privatbil som kvalifiserer for kilometerfradrag, ikke en yrkesbil. Turen er ikke kostnadsført på annen måte.",
  "km.flow.reviewHelp": "Er eieren ansatt, velg vedkommende fra ansattlisten og send til reiseregning. For eier uten ansettelsesforhold må rolle og rapportering avklares. Denne oppgjørsflyten støttes foreløpig ikke. Turen er lagret uten bokføring.",
  "km.flow.portalLog": "Kjørebok",
  "km.flow.newMileage": "Registrer kjøretur",
  "km.flow.precision": "Kontroller rute og distanse før innsending.",
  "km.flow.kmUnit": "km",
  "err.mileage.year": "Satsene for dette året må avklares før turen kan behandles.",
  "err.mileage.rate": "Oppgi en gyldig kilometersats.",
  "err.mileage.identity": "Turen mangler gyldig identifikator.",
  "err.mileage.locked": "Turen er bokført eller knyttet til en reiseregning. Åpne dokumentet for å fortsette.",
  "err.mileage.country": "Denne kjørebokflyten støtter foreløpig bare norske foretak.",
  "err.mileage.legacy": "Eldre turer må kontrolleres før sletting.",
  "err.mileage.fields": "Fyll ut gyldig dato, rute, formål og distanse.",
  "err.mileage.employee": "Velg en aktiv ansatt.",
  "err.mileage.missing": "Fant ikke turen.",
  "err.mileage.proprietor": "Bare innehaverens næringskjøring med kvalifiserende privatbil kan bokføres her.",
  "err.mileage.confirmation": "Bekreft at bilen kvalifiserer for kilometerfradrag.",
  "err.mileage.threshold": "Ved 6 000 km eller mer må privatbil eller yrkesbil avklares før bokføring.",
  "err.mileage.submission": "Velg en ansatt og næringskjøring med privatbil før innsending.",
  "err.mileage.conflict": "Reiseregningen finnes allerede. Åpne den eksisterende reisen.",
  "err.mileage.operation": "Denne kjørebokhandlingen støttes ikke.",
  "err.mileage.scoped": "Bruk kjøreboken for å endre denne turen.",
  "err.mileage.journal": "Turen har allerede et bilag. Åpne bilaget for å fortsette.",
  "km.flow.rateHelp": "For 2026 er ENK-fradraget og skattefri grunnsats 3,50 kr/km. Ansatte kan etter avtale få statens sats på 5,30 kr/km; overskytende del er skattepliktig.",
  "km.flow.amountHelp": "Beregnet beløp er ikke nødvendigvis bokført eller skattefritt. Velg fører og bruk handlingen på turen for å gå videre.",
  "km.flow.saveHelp": "Lagrer dokumentasjonen uten bokføring. Åpne turen for å velge fører, bokføre ENK-fradrag eller sende til reiseregning.",
  "km.flow.pageHelp": "Registrer turer for innehaver eller ansatte. Privatbil og virksomhetens bil behandles forskjellig. Registrering alene gir ingen regnskapspostering.",
  "km.flow.rejected": "Avvist – se reiseregning",
  "km.flow.notLoaded": "Bilaget er ikke lastet ennå. Vent litt og prøv igjen.",
  "km.vehicles.optional": "Valgfritt. Velg et registrert kjøretøy for statistikk per bil.",
  "km.vehicles.title": "Kjøretøy",
  "km.vehicles.add": "Registrer kjøretøy",
  "km.vehicles.registration": "Registreringsnummer",
  "km.vehicles.name": "Navn (valgfritt)",
  "km.vehicles.total": "Totalt",
  "km.vehicles.help": "Kilometer i {year}. Registeret er kun for kjørebok, ikke eiendeler.",
  "km.vehicles.unassigned": "Uten kjøretøy",
  "km.vehicles.archived": "Arkivert",
  "km.vehicles.remove": "Slett / arkiver",
  "km.vehicles.removeHelp": "Ubrukte kjøretøy slettes. Kjøretøy som er brukt på turer arkiveres og beholdes i historikken.",
  "km.vehicles.history": "Endringer gjelder nye turer. Eksisterende turer beholder registreringsnummer og biltype.",
  "km.vehicles.confirm": "Jeg bekrefter at turen gjelder yrkeskjøring med privatbil, og at den ikke allerede er sendt inn til oppgjør.",
  "err.mileage.vehicleInvalid": "Oppgi gyldig registreringsnummer og biltype.",
  "err.mileage.vehicleDuplicate": "Registreringsnummeret finnes allerede, også blant arkiverte kjøretøy.",
  "err.mileage.vehicleMissing": "Velg et aktivt kjøretøy."
});
